var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"main-wrapper"}},[((_vm.hasAccess() && _vm.isLaptop) || (_vm.hasAccess() && _vm.isPublicProfile))?_c('Header'):(!_vm.hasAccess() && !_vm.assessmentMobile)?_c('GuestHeader'):_vm._e(),_c('AppMain'),(!_vm.hasAccess())?_c('MobBottomNav'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }